import "core-js/modules/es.function.name";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';

var Command =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Command, _React$Component);

  function Command() {
    _classCallCheck(this, Command);

    return _possibleConstructorReturn(this, _getPrototypeOf(Command).apply(this, arguments));
  }

  _createClass(Command, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          children = _this$props.children;
      return React.createElement("div", {
        className: "command",
        "data-command": name
      }, children);
    }
  }]);

  return Command;
}(React.Component);

export default Command;